// @core/api/endpoints/authn/enable_two_factor_auth.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  EnableTwoFactorAuthRequest,
  EnableTwoFactorAuthResponse,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Enable two-factor authentication
 * Initiates 2FA setup by generating a TOTP secret and backup codes. Returns a QR code URL for authenticator apps. The user must verify with a code before 2FA is fully enabled.
 */
export async function EnableTwoFactorAuth(
  data: EnableTwoFactorAuthRequest,
  options?: RequestOptions
): Promise<EnableTwoFactorAuthResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/auth/2fa/enable`;
  const requestOptions = options;
  return client.post<EnableTwoFactorAuthResponse>(requestPath, data, requestOptions);
}
